module.exports = "/_next/static/images/Tech-Support-df236cd53ea87015cf4ceac089330a2f.jpg";